import { useEffect, useState } from 'react';
import {
    CollaboratorCustomField,
    CollaboratorCustomFieldsService,
} from '@services/CollaboratorCustomFieldsService';

export type CollaboratorDetailTab =
    | 'perfil'
    | 'fichajes'
    | 'legajo'
    | 'auditoria'
    | 'turnos-dedicados';

interface UseColaboradorDetailModalScreenViewModelProps {
    isOpen: boolean;
    orgID: string;
    customFieldsService: CollaboratorCustomFieldsService;
}

export function useColaboradorDetailModalScreenViewModel({
    isOpen,
    orgID,
    customFieldsService,
}: UseColaboradorDetailModalScreenViewModelProps) {
    const [selectedTab, setSelectedTab] = useState<CollaboratorDetailTab>('perfil');
    const [customFields, setCustomFields] = useState<CollaboratorCustomField[]>([]);

    useEffect(() => {
        if (isOpen) {
            setSelectedTab('perfil');
        }
    }, [isOpen]);

    useEffect(() => {
        if (!isOpen) {
            return;
        }

        void customFieldsService
            .getFields(orgID)
            .then(setCustomFields)
            .catch(() => setCustomFields([]));
    }, [customFieldsService, isOpen, orgID]);

    return {
        selectedTab,
        setSelectedTab,
        activeCustomFields: customFields.filter((field) => field.isActive),
    };
}
